<aside class="app-sidebar" [class.closed]="!sidebarService.isOpen()">
  <nav class="sidebar-nav">
    @for (item of menuItems(); track $index) {
      @if (!item.children) {
        <a
          [routerLink]="item.path"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          class="nav-item-single"
        >
          @if (item.icon) {
            <mat-icon>{{ item.icon }}</mat-icon>
          }
          <span>{{ item.label | translate }}</span>
        </a>
      } @else {
        <div class="nav-group">
          <button
            class="nav-title-btn"
            (click)="toggleGroup(item)"
            [class.active]="isGroupOpen(item)"
          >
            <mat-icon class="group-icon-arrow"> chevron_right </mat-icon>
            @if (item.icon) {
              <mat-icon class="group-icon-main">{{ item.icon }}</mat-icon>
            }
            <span>{{ item.label | translate }}</span>
          </button>

          @if (isGroupOpen(item)) {
            <div class="nav-subitems" @slideInOut>
              @for (child of item.children; track $index) {
                <a [routerLink]="child.path" routerLinkActive="active" class="nav-subitem">
                  @if (child.icon) {
                    <mat-icon class="subitem-icon">{{ child.icon }}</mat-icon>
                  }
                  <span>{{ child.label | translate }}</span>
                </a>
              }
            </div>
          }
        </div>
      }
    }
  </nav>

  <div class="sidebar-footer">
    <a class="nav-item-single" href="javascript:void(0)">
      @if (sidebarService.isOpen()) {
        <mat-icon>help_outline</mat-icon>
        <span>{{ 'SIDEBAR.HELP_CENTER' | translate }}</span>
      }
    </a>
    <a class="nav-item-single logout" (click)="logout()" href="javascript:void(0)">
      <mat-icon>logout</mat-icon>
      @if (sidebarService.isOpen()) {
        <span>{{ 'SIDEBAR.LOGOUT' | translate }}</span>
      }
    </a>
  </div>
</aside>
